import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
import Cookies from "js-cookie";
import axios from "axios";
import { UpdateParameterValues } from "../services/City";
import { label } from "aws-amplify";
function ConstructionCost(props) {
  const [value, setValue] = React.useState(0);
  const [lable, setlable] = React.useState(null);
  const [valueperhome, setValueperhome] = React.useState(0);
  const [valueperproject, setValueperproject] = React.useState(0);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [IsStyle, SetStyle] = React.useState("form-control construction ");
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [isChecked, setIsChecked] = React.useState(null);
  const [IsReadOnly, SetReadOnly] = React.useState(false);
  const [state, setState] = React.useState({ values: [] });
  const [statehard, setStatehard] = React.useState({ values: [] });
  const [advsoftcount, setadvsoftcount] = React.useState(0);
  const [advhardcount, setadvhardcount] = React.useState(0);
  const [advsoftcountorder, setadvsoftcountorder] = React.useState(2.001);
  const [advhardcountorder, setadvhardcountorder] = React.useState(48.001);
  const [softstyle, setsoftstyle] = React.useState("hide ");
  const [hardstyle, sethardstyle] = React.useState("hide ");
  const [isPressing, setIsPressing] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {




    setlable(props.name)
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.isSite == 0) {
      SetReadOnly(true);
    }
    if (props.id == 289 || props.wholeEl.ParameterTypeId == 11) {
      if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 287 && item.structureType == props.structureType).value == "true") {
        setsoftstyle("")
      }
    }
    if (props.id == 290 || props.wholeEl.ParameterTypeId == 12) {
      if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 288 && item.structureType == props.structureType).value == "true") {
        sethardstyle("")
      }
    }
    if (props.id == 287 || props.id == 288) {

      if (props.value == "False" || props.value == 0 || props.value == "" || props.value == "false") {
        // if(props.id==287){
        //   setsoftstyle("display:'none'")
        // }
        // if(props.id==288){
        //   sethardstyle("display:'none'")
        // }
        setIsChecked(false);
      }

      else {

        setIsChecked(true);
      }
    }
    setValue(props.value);
    if (props.value == "") {
      setValue(0);
    }
    if (props.id == 306 || props.id == 307) {
      setValue(commafy(props.value));
    }
    else {
      setValue(props.value);
    }
    setValueperhome(props.wholeEl.perhomevalue);
    setValueperproject(props.wholeEl.perprojectvalue);


    if (props.id == 198) {
      SetStyle("form-control construction leftTop");
      if (props.wholeEl.ischecked === true) {
        var pclass = IsStyle;
        SetStyle("form-control construction leftTop ischecked");
      }
    }
    else if (props.id == 229) {
      SetStyle("form-control construction RightTop");
      if (props.wholeEl.ischecked === true) {
        var pclass = IsStyle;
        SetStyle("form-control construction RightTop ischecked");
      }
    }
    else if (props.id == 239) {
      SetStyle("form-control construction RightTop");
      if (props.wholeEl.ischecked === true) {
        var pclass = IsStyle;
        SetStyle("form-control construction RightTop ischecked");
      }
    }
    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);
    else {
      if (props.wholeEl.ischecked === true) {
        var pclass = IsStyle;
        SetStyle(pclass + " ischecked");
      }
    }

    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);
  }, []);

  async function getUserDefault() {

  }

  function commafy(num) {
    var str = num.toString().split('.');
    if (str[0].length >= 5) {
      str[0] = str[0].replaceAll(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 5) {
      str[1] = str[1].replaceAll(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
  }
  const saverow = (e) => {
    setLoading(true)
    let checkid = e.target.id;
    let structuretype = checkid.split('-');
    let ParameterName = "";
    let ParameterTypeId = 11;
    let value = "";
    let IsManual = 0;
    let perhomevalue = "";
    let perprojectvalue = "";
    let structureType = structuretype[1];
    if (checkid != "") {
      if (structuretype[4] == "soft") {
        ParameterTypeId = 11;
        perhomevalue = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perhome-soft").value;
        value = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-persqt-soft").value;
        perprojectvalue = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perproject-soft").value;
        ParameterName = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-label-soft").value;
        IsManual = props.object["Building Cost Breakdown"].find((item) => item.ParameterId == structuretype[2] && item.structureType == structuretype[1]).IsManual;
      }
      if (structuretype[4] == "hard") {
        ParameterTypeId = 12;
        perhomevalue = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perhome-hard").value;
        value = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-persqt-hard").value;
        perprojectvalue = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perproject-hard").value;
        ParameterName = document.getElementById(structuretype[1] + "-" + structuretype[2] + "-label-hard").value;
        IsManual = props.object["Building Cost Breakdown"].find((item) => item.ParameterId == structuretype[2] && item.structureType == structuretype[1]).IsManual;
      }
    }
    if (IsManual == 0) {
      perhomevalue = 0; perprojectvalue = 0;
    }
    if (IsManual == 1) {
      value = 0; perprojectvalue = 0;
    }
    if (IsManual == 2) {
      perhomevalue = 0; value = 0;
    }
    let newArr = [];
    newArr = ({
      Phase: "Building Cost Breakdown",
      ParameterTypeId: ParameterTypeId,
      ParameterId: 0,
      ParameterName: ParameterName,
      value: value,
      ischecked: 0,
      structureType: structureType,
      IsManual: IsManual,
      isComplete: 5,
      perhomevalue: perhomevalue,
      perprojectvalue: perprojectvalue,
      ParamOrder: 0,
    });

    var name = Cookies.get('username');

    let params = {
      username: name,
      Stage: "L",
      formId: 0,
      userType: "DefaultSave",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: structureType,
      Calculations: [newArr],
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    console.log(params)
    return axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        setLoading(false);
        return res.data;
      })
      .catch((e) => {
        setLoading(false);
      });

  }
  const handlePressStart1 = (e) => {


    setTimeout(() => {
      if (isPressing) {

        saverow(e);
      }
    }, 1000); // 1 second delay
  };

  const handlePressEnd1 = () => {

  };
  const handlePressStart = (e) => {


    setTimeout(() => {
      if (isPressing) {

        Deleterow(e);
      }
    }, 1000); // 1 second delay
  };

  const handlePressEnd = () => {

  };
  const Deleterow = (e) => {
    let checkid = e.target.id;
    let structuretype = checkid.split('-');
    var ParameterTypeId = 11;
    if (checkid != "") {
      if (structuretype[4] == "soft") {


        props.object["Building Cost Breakdown"].find((item) => item.ParameterId == structuretype[2] && item.structureType == structuretype[1]).isComplete = 10;
        props.object["Building Cost Breakdown"].find((item) => item.ParameterId == structuretype[2] && item.structureType == structuretype[1]).value = "-99";

        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perhome-soft").value = "-99";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-persqt-soft").value = "-99";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perproject-soft").value = "-99";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-rowsoft").style.display = "none";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-rowsoft").classList.remove("softcost1");
        UpdateParameterValues(structuretype[1], props);
      }
      if (structuretype[4] == "hard") {
        ParameterTypeId = 12;
        props.object["Building Cost Breakdown"].find((item) => item.ParameterId == structuretype[2] && item.structureType == structuretype[1]).isComplete = 10;
        props.object["Building Cost Breakdown"].find((item) => item.ParameterId == structuretype[2] && item.structureType == structuretype[1]).value = "-99";

        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perhome-hard").value = "-99";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-persqt-hard").value = "-99";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-perproject-hard").value = "-99";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-rowhard").style.display = "none";
        document.getElementById(structuretype[1] + "-" + structuretype[2] + "-rowhard").classList.remove("hardcost1");
        UpdateParameterValues(structuretype[1], props);
      }

      var formID = 0;
      let newArr = [];
      newArr = ({
        ParameterId: structuretype[2], ParameterName: lable, ParameterTypeId: ParameterTypeId, value: "-99",
        ischecked: 1, structureType: structuretype[1], IsManual: 0, isComplete: 0, perhomevalue: "-99", perprojectvalue: "-99", ParamOrder: 0,
      });

      var name = Cookies.get('username');
      let params = {
        username: name,
        Stage: "L",
        formId: formID,
        userType: "AutoSave",
        parameters: []
      };
      params.StructureTypes = [{
        StructureType: structuretype[1],
        Calculations: [newArr],
      }
      ]
      params = JSON.stringify({
        Body: params,
      });
      console.log(params)
      return axios
        .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          crossorigin: true,
        })
        .then((res) => {
          // setLoading(false);
          return res.data;
        })
        .catch((e) => {
          // setLoading(false);
        });
    }

  }
  const showtrash = (e) => {
    let checkid = e.target.id;

    let structuretype = checkid.split('-');
    if (structuretype[3] == "soft") {
      var parentDiv = document.getElementsByClassName("softicons");
      for (var i = 0; i < parentDiv.length; i++) {

        parentDiv[i].style.display = "none";
      }
    }
    if (structuretype[3] == "hard") {
      var parentDiv = document.getElementsByClassName("hardicons");
      for (var i = 0; i < parentDiv.length; i++) {

        parentDiv[i].style.display = "none";
      }
    }
    document.getElementById(structuretype[0] + "-" + structuretype[1] + "-del-" + structuretype[3]).style.display = "inherit";
    document.getElementById(structuretype[0] + "-" + structuretype[1] + "-save-" + structuretype[3]).style.display = "inherit";
    document.getElementById(structuretype[0] + "-" + structuretype[1] + "-drag-" + structuretype[3]).style.display = "inherit";
  }
  const hidetrash = (e) => {

    if (e.target.id != null) {
      let checkid = e.target.id;
      let structuretype = checkid.split('-');
      //document.getElementById(structuretype[0]+"-"+structuretype[1]+"-del-"+structuretype[3]).style.display = "none";
    }
  }
  function createUIhard() {
    return statehard.values.map((el, i) =>

      <div draggable data-position={i}
        onDragStart={props.onDragStart}
        onDragOver={props.onDragOver}
        onDrop={props.onDrop}
        onDragLeave={props.onDragLeave} id={props.structureType + "-" + i + "-rowhard"} class={" row hardcost1"} style={{ width: "100%" }}>
        <div class="col-md-3 " onFocus={showtrash} id={props.structureType + "-" + i + "-div-hard"}>
          <div class="from  d-flex  align-items-center ">
            {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
            <a tooltip="Drag" flow="down" id={props.structureType + "-" + i + "-drag-hard"} class="hardicons"
              style={{ marginRight: "0.2rem", marginTop: "0.5rem" }} >
              <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + i + "-drag-hard"} class=" fa fa-list"></i>


            </a>

            <a tooltip="Hold to save" flow="down" id={props.structureType + "-" + i + "-save-hard"} class="hardicons" onMouseDown={handlePressStart1}
              onMouseUp={handlePressEnd1}
              onMouseLeave={handlePressEnd1} style={{ marginTop: "0.5rem", marginRight: "0.2rem" }}>
              <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + i + "-save-hard"} class="icon1 fa fa-save"></i>

            </a>

            <a tooltip="Hold to delete" flow="down" id={props.structureType + "-" + i + "-del-hard"} class="hardicons" onMouseDown={handlePressStart}
              onMouseUp={handlePressEnd}
              onMouseLeave={handlePressEnd} style={{ marginTop: "0.5rem" }}>
              <i id={"12-" + props.structureType + "-" + i + "-del-hard"} class="icon fa fa-trash"></i>

            </a>

            {/* <label class="" style={{marginLeft:"10%"}} contenteditable="true">{props.name}      

  </label> */}
            <input type="text" onFocus={showtrash} onChange={lableChange} onBlur={lableChange1} id={props.structureType + "-" + i + "-label-hard"} class="form-control" style={{
              marginLeft: "10%", border: "none",
              background: "none",
              color: "black",

              fontSize: "12px",
              fontWeight: "600"
            }} contenteditable="true"
            />
          </div>
        </div>
        <div class="col-md-2 col-2" >
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + i + "-persqt-hard"}
                id={props.structureType + "-" + i + "-persqt-hard"}

                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={"form-control " + props.structureType + "  advhardcost persqt"}
                style={{}}
              />
            </div>
          </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + i + "-perhome-hard"}
                id={props.structureType + "-" + i + "-perhome-hard"}

                onChange={onChangeperhome}
                class={"form-control " + props.structureType + "  advhardcost perhome"}
                style={{}}
              />
            </div> </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + i + "-perproject-hard"}
                id={props.structureType + "-" + i + "-perproject-hard"}

                onChange={onChangeperproject}
                class={"form-control " + props.structureType + "  advhardcost perproject"}
                style={{}}
              />
            </div> </div>
        </div>
      </div>
      // <div >
      //  <input type="text" value={el||''} onChange={handleChange.bind(this, i)} />
      //  <input type='button' value='remove' onClick={removeClick.bind(this, i)}/>
      // </div>          
    )
  }
  function createUIsoft() {

    return state.values.map((el, i) =>

      <div draggable data-position={i}
        onDragStart={props.onDragStart}
        onDragOver={props.onDragOver}
        onDrop={props.onDrop}
        onDragLeave={props.onDragLeave} id={props.structureType + "-" + i + "-rowsoft"} class={" row softcost1"} style={{ width: "100%" }}>
        <div class="col-md-3 " onFocus={showtrash} id={props.structureType + "-" + i + "-div-soft"}>
          <div class="from  d-flex justify-content-between  align-items-center " >
            {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
            <a tooltip="Drag" flow="down" id={props.structureType + "-" + i + "-drag-soft"} class="softicons"
              style={{ marginRight: "0.2rem", marginTop: "0.5rem" }} >
              <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + i + "-drag-soft"} class=" fa fa-list"></i>


            </a>

            <a tooltip="Hold to save" flow="down" id={props.structureType + "-" + i + "-save-soft"} class="softicons " onMouseDown={handlePressStart1}
              onMouseUp={handlePressEnd1}
              onMouseLeave={handlePressEnd1} style={{ marginTop: "0.5rem", marginRight: "0.2rem" }}>
              <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + i + "-save-soft"} class="icon1 fa fa-save"></i>

            </a>

            <a tooltip="Hold to delete" flow="down" id={props.structureType + "-" + i + "-del-soft"} class="softicons" onMouseDown={handlePressStart}
              onMouseUp={handlePressEnd}
              onMouseLeave={handlePressEnd} style={{ marginTop: "0.5rem" }}>
              <i id={"11-" + props.structureType + "-" + i + "-del-soft"} class="icon fa fa-trash"></i>

            </a>


            {/* <label onFocus={showtrash} onBlur={hidetrash} onChange={lableChange} id={props.structureType +"-"+ i+"-label-soft"} class="" style={{marginLeft:"10%"}} contenteditable="true">{props.name}      

  </label> */}
            <input type="text" onFocus={showtrash} onChange={lableChange} onBlur={lableChange1} id={props.structureType + "-" + i + "-label-soft"} class="form-control" style={{
              marginLeft: "10%", border: "none",
              background: "none",
              color: "black",

              fontSize: "12px",
              fontWeight: "600"
            }}
            />


          </div>
        </div>
        <div class="col-md-2 col-2" >
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + i + "-persqt-soft"}
                id={props.structureType + "-" + i + "-persqt-soft"}

                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                class={"form-control " + props.structureType + "  advsoftcost persqt"}
                style={{}}
              />
            </div>
          </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + i + "-perhome-soft"}
                id={props.structureType + "-" + i + "-perhome-soft"}

                onChange={onChangeperhome}
                class={"form-control " + props.structureType + "  advsoftcost perhome"}
                style={{}}
              />
            </div> </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + i + "-perproject-soft"}
                id={props.structureType + "-" + i + "-perproject-soft"}

                onChange={onChangeperproject}
                class={"form-control " + props.structureType + "  advsoftcost perproject"}
                style={{}}
              />
            </div> </div>
        </div>
      </div>
      // <div >
      //  <input type="text" value={el||''} onChange={handleChange.bind(this, i)} />
      //  <input type='button' value='remove' onClick={removeClick.bind(this, i)}/>
      // </div>          
    )
  }

  function handleChange(i, event) {
    let values = [...state.values];
    values[i] = event.target.value;
    setState({ values });
  }

  function addClick(structureType) {
    setState(prevState => ({ values: [...prevState.values, 'ss'] }))
    let newArr = "";
    newArr = ({
      Phase: "Building Cost Breakdown",
      ParameterTypeId: 11,
      ParameterId: parseInt(advsoftcount),
      ParameterName: "Custom Field",
      value: "",
      ischecked: 0,
      structureType: structureType,
      IsManual: 0,
      isComplete: 5,
      perhomevalue: "",
      perprojectvalue: "",
      ParamOrder: advsoftcountorder,
    });
    // var myJsonString = JSON.stringify(newArr)
    props.object["Building Cost Breakdown"].push(newArr)
    props.object["Building Cost Breakdown"] = props.object["Building Cost Breakdown"].sort((a, b) => a.ParamOrder - b.ParamOrder);
    console.log(props);
    let advsoftcounted = parseInt(advsoftcount) + 1;
    setadvsoftcount(advsoftcounted);
    let advsoftcountedorder = parseInt(advsoftcountorder) + 1;
    setadvsoftcountorder(advsoftcountedorder);
  }
  function addClickhard(structureType) {
    setStatehard(prevState => ({ values: [...prevState.values, 'ss'] }))
    let newArr = "";
    newArr = ({
      Phase: "Building Cost Breakdown",
      ParameterTypeId: 12,
      ParameterId: parseInt(advhardcount),
      ParameterName: "Custom Field",
      value: "",
      ischecked: 0,
      structureType: structureType,
      IsManual: 0,
      isComplete: 5,
      perhomevalue: "",
      perprojectvalue: "",
      ParamOrder: advhardcountorder,
    });
    props.object["Building Cost Breakdown"].push(newArr)
    props.object["Building Cost Breakdown"] = props.object["Building Cost Breakdown"].sort((a, b) => a.ParamOrder - b.ParamOrder);

    let advsoftcounted = parseInt(advhardcount) + 1;
    setadvhardcount(advsoftcounted);
    let advsoftcountedorder = parseInt(advhardcountorder) + 1;
    setadvhardcountorder(advsoftcountedorder);
  }
  function removeClickhard(i, structureType) {

    let values = [...statehard.values];
    values.splice(i, 1);
    setStatehard({ values });
    props.object["Building Cost Breakdown"].find((item) => item.ParameterId == i && item.structureType == structureType && item.ParameterTypeId == 12).isComplete = 10;
    props.object["Building Cost Breakdown"].find((item) => item.ParameterId == i && item.structureType == structureType && item.ParameterTypeId == 12).value = "-99";
    UpdateParameterValues(structureType, props);
  }
  function removeClick(i, structureType) {

    let values = [...state.values];
    values.splice(i, 1);
    setState({ values });
    props.object["Building Cost Breakdown"].find((item) => item.ParameterId == i && item.structureType == structureType && item.ParameterTypeId == 11).isComplete = 10;
    props.object["Building Cost Breakdown"].find((item) => item.ParameterId == i && item.structureType == structureType && item.ParameterTypeId == 11).value = "-99";

    console.log(props);
    UpdateParameterValues(structureType, props);
  }


  const lableChange = (e) => {
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = checkid.split('-')[0];

    if (structuretype == "SingleFamily") {
      structuretype = "Single Family"
    }
    let type = checkid.split('-');
    if (type[3] == "soft") {

      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype && item.ParameterTypeId == 11).ParameterName = e.target.value;
    }
    if (type[3] == "hard") {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype && item.ParameterTypeId == 12).ParameterName = e.target.value;
    }

    setlable(e.target.value)

  }

  const lableChange1 = (e) => {
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = checkid.split('-')[0];
    var ParameterTypeId = 11;
    var perhomevalue = 0;
    var value1 = 0;
    var perprojectvalue = 0;
    if (structuretype == "SingleFamily") {
      structuretype = "Single Family"
    }
    let type = checkid.split('-');
    if (type[3] == "soft") {

      ParameterTypeId = 11;
      value1 = document.getElementById(structuretype + "-" + type[1] + "-persqt-soft").value;
      perhomevalue = document.getElementById(structuretype + "-" + type[1] + "-perhome-soft").value;
      perprojectvalue = document.getElementById(structuretype + "-" + type[1] + "-perproject-soft").value;
    }
    if (type[3] == "hard") {
      ParameterTypeId = 12;
      value1 = document.getElementById(structuretype + "-" + type[1] + "-persqt-hard").value;
      perhomevalue = document.getElementById(structuretype + "-" + type[1] + "-perhome-hard").value;
      perprojectvalue = document.getElementById(structuretype + "-" + type[1] + "-perproject-hard").value;
    }


    var formID = 0;
    let newArr = [];
    newArr = ({
      ParameterId: type[1], ParameterName: lable, ParameterTypeId: ParameterTypeId, value: value1,
      ischecked: 1, structureType: structuretype, IsManual: 0, isComplete: 0, perhomevalue: perhomevalue, perprojectvalue: perprojectvalue, ParamOrder: 0,
    });

    var name = Cookies.get('username');
    let params = {
      username: name,
      Stage: "L",
      formId: formID,
      userType: "AutoSave",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: structuretype,
      Calculations: [newArr],
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    return axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        // setLoading(false);
        return res.data;
      })
      .catch((e) => {
        // setLoading(false);
      });
  }

  const onChange1 = (e) => {

    setIsChecked(!isChecked);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = checkid.split('-')[0];

    if (e.target.checked == true) {
      setValue("checked");

      if (parameterid == 288) {
        if (structureType == "Townhome" || structureType == "Rowhouse" || structureType == "Cottage") {
          document.getElementById(structuretype + "-110").style.borderTopLeftRadius = "0px";
        }
        if (structureType == "Single Family") {
          document.getElementById(structuretype + "-109").style.borderTopLeftRadius = "0px";
        }
        if (structureType == "Condo" || structureType == "Apartment") {
          document.getElementById(structuretype + "-114").style.borderTopLeftRadius = "0px";
        }
        document.getElementById(structuretype + "-239").classList.remove("RightTop");
        document.getElementById("290-" + structuretype + "-btn").classList.remove("hide");

        var parentDiv = document.getElementsByClassName("hardcost1");
        for (var i = 0; i < parentDiv.length; i++) {

          parentDiv[i].style.display = "inherit";
        }

        // if(structuretype=="Single Family")
        // {
        //   document.getElementById("row-"+structuretype+"-109").style.display = "none";
        //   document.getElementById("row1-"+structuretype+"-109").style.display = "none";
        //   document.getElementById("row-"+structuretype+"-97").style.display = "none";
        // }
        // if(structuretype=="Rowhouse" || structuretype=="Townhome" || structuretype=="Cottage")
        // {

        // }
        // if(structuretype=="Condo")
        // {
        //   document.getElementById("row-"+structuretype+"-114").style.display = "none";
        //   document.getElementById("row1-"+structuretype+"-114").style.display = "none";
        //   document.getElementById("row-"+structuretype+"-103").style.display = "none";
        // }
        // if(structuretype=="Apartment")
        // {
        //   document.getElementById("row-"+structuretype+"-113").style.display = "none";
        //   document.getElementById("row1-"+structuretype+"-113").style.display = "none";
        //   document.getElementById("row-"+structuretype+"-102").style.display = "none";
        // }
        document.getElementById("row-" + structuretype + "-110").style.display = "none";
        document.getElementById("row1-" + structuretype + "-110").style.display = "none";
        document.getElementById("row-" + structuretype + "-99").style.display = "none";
        document.getElementById("row-" + structuretype + "-239").style.display = "none";
      }

      if (parameterid == 287) {
        document.getElementById(structuretype + "-198").classList.remove("leftTop");
        document.getElementById(structuretype + "-229").classList.remove("RightTop");
        document.getElementById("289-" + structuretype + "-btn").classList.remove("hide");

        var parentDiv = document.getElementsByClassName("softcost1");
        for (var i = 0; i < parentDiv.length; i++) {

          parentDiv[i].style.display = "inherit";
        }
        document.getElementById("row-" + structuretype + "-198").style.display = "none";
        document.getElementById("row1-" + structuretype + "-198").style.display = "none";
        document.getElementById("row-" + structuretype + "-229").style.display = "none";
        document.getElementById("row-" + structuretype + "-201").style.display = "none";
        // if(structuretype=="Single Family")
        // {
        //   document.getElementById("row-"+structuretype+"-200").style.display = "none";
        // }
        // if(structuretype=="Rowhouse" || structuretype=="Townhome" || structuretype=="Cottage")
        // {

        // }
        // if(structuretype=="Apartment" || structuretype=="Condo")
        // {
        //   document.getElementById("row-"+structuretype+"-202").style.display = "none";
        // }

      }

      //props.setData({...props.wholeEl,value : "true",ischecked:true});
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = "true";

    }
    else {

      setValue("");

      if (parameterid == 288) {
        if (structureType == "Townhome" || structureType == "Rowhouse" || structureType == "Cottage") {
          document.getElementById(structuretype + "-110").style.borderTopLeftRadius = "5px";
        }
        if (structureType == "Single Family") {
          document.getElementById(structuretype + "-109").style.borderTopLeftRadius = "0px";
        }
        if (structureType == "Condo" || structureType == "Apartment") {
          document.getElementById(structuretype + "-114").style.borderTopLeftRadius = "0px";
        }
        document.getElementById(structuretype + "-239").classList.add("RightTop");
        document.getElementById("290-" + structuretype + "-btn").classList.add("hide");

        var parentDiv = document.getElementsByClassName("hardcost1");

        for (var i = 0; i < parentDiv.length; i++) {

          parentDiv[i].style.display = "none";
        }
        // if(structuretype=="Single Family")
        // {
        //   document.getElementById("row-"+structuretype+"-109").style.display = "block";
        //   document.getElementById("row1-"+structuretype+"-109").style.display = "block";
        //   document.getElementById("row-"+structuretype+"-97").style.display = "block";
        // }
        // if(structuretype=="Rowhouse" || structuretype=="Townhome" || structuretype=="Cottage")
        // {

        // }
        // if(structuretype=="Condo")
        // {
        //   document.getElementById("row-"+structuretype+"-114").style.display = "block";
        //   document.getElementById("row1-"+structuretype+"-114").style.display = "block";
        //   document.getElementById("row-"+structuretype+"-103").style.display = "block";
        // }
        // if(structuretype=="Apartment")
        // {
        //   document.getElementById("row-"+structuretype+"-113").style.display = "block";
        //   document.getElementById("row1-"+structuretype+"-113").style.display = "block";
        //   document.getElementById("row-"+structuretype+"-102").style.display = "block";
        // }
        document.getElementById("row-" + structuretype + "-110").style.display = "block";
        document.getElementById("row1-" + structuretype + "-110").style.display = "block";
        document.getElementById("row-" + structuretype + "-99").style.display = "block";
        document.getElementById("row-" + structuretype + "-239").style.display = "block";
      }
      if (parameterid == 287) {

        document.getElementById(structuretype + "-198").classList.add("leftTop");
        document.getElementById(structuretype + "-229").classList.add("RightTop");
        document.getElementById("289-" + structuretype + "-btn").classList.add("hide");
        var parentDiv = document.getElementsByClassName("softcost1");

        for (var i = 0; i < parentDiv.length; i++) {

          parentDiv[i].style.display = "none";
        }
        document.getElementById("row-" + structuretype + "-198").style.display = "block";
        document.getElementById("row1-" + structuretype + "-198").style.display = "block";
        document.getElementById("row-" + structuretype + "-229").style.display = "block";
        document.getElementById("row-" + structuretype + "-201").style.display = "block";
        // if(structuretype=="Single Family")
        // {
        //   document.getElementById("row-"+structuretype+"-200").style.display = "block";
        // }
        // if(structuretype=="Rowhouse" || structuretype=="Townhome" || structuretype=="Cottage")
        // {

        // }
        // if(structuretype=="Apartment" || structuretype=="Condo")
        // {
        //   document.getElementById("row-"+structuretype+"-202").style.display = "block";
        // }

      }

      //props.setData({...props.wholeEl,value : "false",ischecked:true});
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).value = "False";

    }
    UpdateParameterValues(structuretype, props);
    var formID = Cookies.get('FormID');
    let newArr = [];
    newArr = ({
      ParameterId: parameterid, ParameterName: lable, ParameterTypeId: props.ParameterTypeId, value: e.target.checked,
      ischecked: 1, structureType: structuretype, IsManual: 0, isComplete: 0, perhomevalue: 0, perprojectvalue: 0, ParamOrder: 0,
    });

    var name = Cookies.get('username');
    let params = {
      username: name,
      Stage: "L",
      formId: formID,
      userType: "AutoSave",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: structuretype,
      Calculations: [newArr],
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    console.log(params)
    return axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        // setLoading(false);
        return res.data;
      })
      .catch((e) => {
        // setLoading(false);
      });
  };
  const onChangeperproject = (e) => {

    setValueperproject(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-');
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    var homesqure = 0;
    if (structuretype == "Single Family") {
      homesqure = document.getElementById(structuretype + "-67").value;
    }
    if (structuretype == "Townhome" || structuretype == "Rowhouse" || structuretype == "Cottage") {
      homesqure = document.getElementById(structuretype + "-215").value;
    }
    if (structuretype == "Apartment" || structuretype == "Condo") {
      homesqure = document.getElementById(structuretype + "-216").value;
    }
    var NumberOfHomes = 0;
    if (structuretype == "Single Family") {
      NumberOfHomes = document.getElementById(structuretype + "-188").value;
    }
    if (structuretype == "Townhome" || structuretype == "Rowhouse" || structuretype == "Cottage") {
      NumberOfHomes = document.getElementById(structuretype + "-30").value;
    }
    if (structuretype == "Apartment" || structuretype == "Condo") {
      NumberOfHomes = document.getElementById(structuretype + "-80").value;
    }
    var ParameterTypeId = 0;
    if (parameterid[3] == "soft") {
      ParameterTypeId = 11;
      document.getElementById(checkid).style.background = "#e7f0fa";
      if (parameterid[2] == "perproject") {
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perhome-soft").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-soft").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perhome-soft").value = Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes);
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-soft").value = ((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2);
        setValueperhome(Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes));
        setValue(((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2));
        if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]) != null) {

          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perhomevalue = Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).value = ((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perprojectvalue = e.target.value.replaceAll(',', '');
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).IsManual = 2;
        }
      }

    }
    if (parameterid[3] == "hard") {
      ParameterTypeId = 12;
      //props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType==structuretype[0]).ischecked=true;
      document.getElementById(checkid).style.background = "#e7f0fa";
      if (parameterid[2] == "perproject") {
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perhome-hard").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-hard").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perhome-hard").value = Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes);
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-hard").value = ((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2);

        setValueperhome(Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes));
        setValue(((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2));
        if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]) != null) {
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perhomevalue = Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).value = ((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perprojectvalue = e.target.value.replaceAll(',', '');
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).IsManual = 2;
        }
      }

    }
    //props.setData({...props.wholeEl,value : e.target.value,ischecked:true})

    if (e.target.value != "") {
      UpdateParameterValues(structuretype, props);
      //document.getElementById(e.target.id).value="0";
    }
    // console.log(props);
    var formID = Cookies.get('FormID');
    let newArr = [];
    newArr = ({
      ParameterId: parameterid, ParameterName: lable, ParameterTypeId: ParameterTypeId, value: ((parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes) / homesqure).toFixed(2),
      ischecked: 1, structureType: structuretype, IsManual: 0, isComplete: 0, perhomevalue: Math.round(parseFloat(e.target.value.replaceAll(',', '')) / NumberOfHomes), perprojectvalue: e.target.value, ParamOrder: 0,
    });

    var name = Cookies.get('username');
    let params = {
      username: name,
      Stage: "L",
      formId: formID,
      userType: "AutoSave",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: structuretype,
      Calculations: [newArr],
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    console.log(params)
    return axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        // setLoading(false);
        return res.data;
      })
      .catch((e) => {
        // setLoading(false);
      });
  }
  const onChangeperhome = (e) => {

    setValueperhome(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    var homesqure = 0;
    if (structuretype == "Single Family") {
      homesqure = document.getElementById(structuretype + "-67").value;
    }
    if (structuretype == "Townhome" || structuretype == "Rowhouse" || structuretype == "Cottage") {
      homesqure = document.getElementById(structuretype + "-215").value;
    }
    if (structuretype == "Apartment" || structuretype == "Condo") {
      homesqure = document.getElementById(structuretype + "-216").value;
    }
    var NumberOfHomes = 0;
    if (structuretype == "Single Family") {
      NumberOfHomes = document.getElementById(structuretype + "-188").value;
    }
    if (structuretype == "Townhome" || structuretype == "Rowhouse" || structuretype == "Cottage") {
      NumberOfHomes = document.getElementById(structuretype + "-30").value;
    }
    if (structuretype == "Apartment" || structuretype == "Condo") {
      NumberOfHomes = document.getElementById(structuretype + "-80").value;
    }
    var ParameterTypeId = 0;
    if (parameterid[3] == "soft") {
      //props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType==structuretype[0]).ischecked=true;
      document.getElementById(checkid).style.background = "#e7f0fa";
      ParameterTypeId = 11;
      if (parameterid[2] == "perhome") {
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perproject-soft").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-soft").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perproject-soft").value = Math.round(parseFloat(e.target.value.replaceAll(',', '')) * NumberOfHomes);
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-soft").value = ((parseFloat(e.target.value.replaceAll(',', '')) / homesqure)).toFixed(2);
        setValueperproject(Math.round(parseFloat(e.target.value.replaceAll(',', '')) * NumberOfHomes));
        setValue(((parseFloat(e.target.value.replaceAll(',', ''))) / homesqure).toFixed(2));
        if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]) != null) {
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perhomevalue = e.target.value.replaceAll(',', '');
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).value = ((parseFloat(e.target.value.replaceAll(',', ''))) / homesqure).toFixed(2);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perprojectvalue = Math.round(parseFloat(e.target.value.replaceAll(',', '')) * NumberOfHomes);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).IsManual = 1;
        }
      }

    }

    if (parameterid[3] == "hard") {
      //props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType==structuretype[0]).ischecked=true;
      document.getElementById(checkid).style.background = "#e7f0fa";
      ParameterTypeId = 12;
      if (parameterid[2] == "perhome") {
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perproject-hard").style.background = "#f7fafd";
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-hard").style.background = "#f7fafd";

        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-perproject-hard").value = Math.round(parseFloat(e.target.value.replaceAll(',', '')) * NumberOfHomes);
        document.getElementById(parameterid[0] + "-" + parameterid[1] + "-persqt-hard").value = ((parseFloat(e.target.value.replaceAll(',', '')) / homesqure)).toFixed(2);
        setValueperproject(Math.round(parseFloat(e.target.value) * NumberOfHomes));
        setValue(((parseFloat(e.target.value.replaceAll(',', ''))) / homesqure).toFixed(2));
        if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]) != null) {
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perhomevalue = e.target.value.replaceAll(',', '');
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).value = ((parseFloat(e.target.value.replaceAll(',', ''))) / homesqure).toFixed(2);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).perprojectvalue = Math.round(parseFloat(e.target.value.replaceAll(',', '')) * NumberOfHomes);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType == parameterid[0]).IsManual = 1;
        }
      }

    }
    //props.setData({...props.wholeEl,value : e.target.value,ischecked:true})

    if (e.target.value != "") {
      UpdateParameterValues(structuretype, props);
      //document.getElementById(e.target.id).value="0";

      var formID = Cookies.get('FormID');
      let newArr = [];
      newArr = ({
        ParameterId: parameterid, ParameterName: lable, ParameterTypeId: ParameterTypeId, value: ((parseFloat(e.target.value.replaceAll(',', ''))) / homesqure).toFixed(2),
        ischecked: 1, structureType: structuretype, IsManual: 0, isComplete: 0, perhomevalue: e.target.value, perprojectvalue: Math.round(parseFloat(e.target.value.replaceAll(',', '')) * NumberOfHomes), ParamOrder: 0,
      });

      var name = Cookies.get('username');
      let params = {
        username: name,
        Stage: "L",
        formId: formID,
        userType: "AutoSave",
        parameters: []
      };
      params.StructureTypes = [{
        StructureType: structuretype,
        Calculations: [newArr],
      }
      ]
      params = JSON.stringify({
        Body: params,
      });
      console.log(params)
      return axios
        .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          crossorigin: true,
        })
        .then((res) => {
          // setLoading(false);
          return res.data;
        })
        .catch((e) => {
          // setLoading(false);
        });
    }
  }
  const onChange = (e) => {

    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid1 = checkid.split('-')
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    var homesqure = 0;
    if (structuretype == "Single Family") {
      homesqure = document.getElementById(structuretype + "-67").value;
    }
    if (structuretype == "Townhome" || structuretype == "Rowhouse" || structuretype == "Cottage") {
      homesqure = document.getElementById(structuretype + "-215").value;
    }
    if (structuretype == "Apartment" || structuretype == "Condo") {
      homesqure = document.getElementById(structuretype + "-216").value;
    }
    var NumberOfHomes = 0;
    if (structuretype == "Single Family") {
      NumberOfHomes = document.getElementById(structuretype + "-188").value;
    }
    if (structuretype == "Townhome" || structuretype == "Rowhouse" || structuretype == "Cottage") {
      NumberOfHomes = document.getElementById(structuretype + "-30").value;
    }
    if (structuretype == "Apartment" || structuretype == "Condo") {
      NumberOfHomes = document.getElementById(structuretype + "-80").value;
    }
    var ParameterTypeId = 0;
    if (parameterid1[3] == "soft") {
      //props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType==structuretype[0]).ischecked=true;
      document.getElementById(checkid).style.background = "#e7f0fa";
      ParameterTypeId = 11;
      if (parameterid1[2] == "persqt") {
        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perhome-soft").style.background = "#f7fafd";
        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perproject-soft").style.background = "#f7fafd";

        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perproject-soft").value = Math.round((parseFloat(e.target.value.replaceAll(',', '')) * homesqure) * NumberOfHomes);
        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perhome-soft").value = Math.round((parseFloat(e.target.value.replaceAll(',', '')) * homesqure));
        setValueperproject(Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure) * NumberOfHomes);
        setValueperhome(Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure));
        if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]) != null) {
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).value = e.target.value.replaceAll(',', '');

          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).perhomevalue = ((parseFloat(e.target.value.replaceAll(',', '')) * homesqure)).toFixed(2);

          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).perprojectvalue = (Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure) * NumberOfHomes);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).IsManual = 0;
        }
      }
    }
    if (parameterid1[3] == "hard") {
      //props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid[1] && item.structureType==structuretype[0]).ischecked=true;
      document.getElementById(checkid).style.background = "#e7f0fa";
      ParameterTypeId = 12;
      if (parameterid1[2] == "persqt") {
        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perhome-hard").style.background = "#f7fafd";
        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perproject-hard").style.background = "#f7fafd";

        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perproject-hard").value = Math.round((parseFloat(e.target.value.replaceAll(',', '')) * homesqure) * NumberOfHomes);
        document.getElementById(parameterid1[0] + "-" + parameterid1[1] + "-perhome-hard").value = Math.round((parseFloat(e.target.value.replaceAll(',', '')) * homesqure));
        setValueperproject(Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure) * NumberOfHomes);
        setValueperhome(Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure));
        if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]) != null) {
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).perhomevalue = Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure);
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).value = e.target.value.replaceAll(',', '');
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).perprojectvalue = Math.round(parseFloat(e.target.value.replaceAll(',', '')) * homesqure) * NumberOfHomes;
          props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid1[1] && item.structureType == parameterid1[0]).IsManual = 0;
        }
      }
    }
    setchecked(true);
    setchecked1(true);
    if (parameterid == 88) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 238 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-88").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-238").style.background = "#f7fafd";

    }
    if (parameterid == 238) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 88 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-238").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-88").style.background = "#f7fafd";
    }

    if (parameterid == 89) {

      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 237 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-89").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-237").style.background = "#f7fafd";
    }
    if (parameterid == 237) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 89 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-237").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-89").style.background = "#f7fafd";
    }

    if (parameterid == 91) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 236 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-91").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-236").style.background = "#f7fafd";
    }
    if (parameterid == 236) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 91 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-236").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-91").style.background = "#f7fafd";
    }

    if (parameterid == 105) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 235 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-105").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-235").style.background = "#f7fafd";
    }
    if (parameterid == 235) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 105 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-235").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-105").style.background = "#f7fafd";
    }

    if (parameterid == 90) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 234 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-90").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-234").style.background = "#f7fafd";
    }
    if (parameterid == 234) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 90 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-234").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-90").style.background = "#f7fafd";
    }

    if (parameterid == 106) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 233 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-106").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-233").style.background = "#f7fafd";
    }
    if (parameterid == 233) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 106 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-233").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-106").style.background = "#f7fafd";
    }

    if (parameterid == 87) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 232 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-87").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-232").style.background = "#f7fafd";
    }
    if (parameterid == 232) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 87 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-232").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-87").style.background = "#f7fafd";
    }
    //ADDU
    if (parameterid == 115) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 104 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 241 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-115").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-104").style.background = "#f7fafd";
      document.getElementById(structuretype + "-241").style.background = "#f7fafd";
    }
    if (parameterid == 104) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 115 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 241 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-104").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-115").style.background = "#f7fafd";
      document.getElementById(structuretype + "-241").style.background = "#f7fafd";
    }
    if (parameterid == 241) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 115 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 104 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-241").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-115").style.background = "#f7fafd";
      document.getElementById(structuretype + "-104").style.background = "#f7fafd";
    }

    //DAADU
    if (parameterid == 240) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 124 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 242 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-240").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-124").style.background = "#f7fafd";
      document.getElementById(structuretype + "-242").style.background = "#f7fafd";
    }
    if (parameterid == 124) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 240 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 242 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-124").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-240").style.background = "#f7fafd";
      document.getElementById(structuretype + "-242").style.background = "#f7fafd";
    }
    if (parameterid == 242) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 124 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 240 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-242").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-124").style.background = "#f7fafd";
      document.getElementById(structuretype + "-240").style.background = "#f7fafd";
    }
    //SF COST T/C/R
    if (parameterid == 198 && (structuretype == "Townhome" || structuretype == "Cottage" || structuretype == "Rowhouse")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 201 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 229 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-198").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-201").style.background = "#f7fafd";
      document.getElementById(structuretype + "-229").style.background = "#f7fafd";
    }
    if (parameterid == 201 && (structuretype == "Townhome" || structuretype == "Cottage" || structuretype == "Rowhouse")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 229 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-201").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-198").style.background = "#f7fafd";
      document.getElementById(structuretype + "-229").style.background = "#f7fafd";
    }
    if (parameterid == 229 && (structuretype == "Townhome" || structuretype == "Cottage" || structuretype == "Rowhouse")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 201 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-229").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-201").style.background = "#f7fafd";
      document.getElementById(structuretype + "-198").style.background = "#f7fafd";
    }


    //MHA FEE T/C/R
    if (parameterid == 186 && (structuretype == "Townhome" || structuretype == "Cottage" || structuretype == "Rowhouse")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 208 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 224 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-186").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-208").style.background = "#f7fafd";
      document.getElementById(structuretype + "-224").style.background = "#f7fafd";
    }
    if (parameterid == 208 && (structuretype == "Townhome" || structuretype == "Cottage" || structuretype == "Rowhouse")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 186 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 224 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-208").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-186").style.background = "#f7fafd";
      document.getElementById(structuretype + "-224").style.background = "#f7fafd";
    }
    if (parameterid == 224 && (structuretype == "Townhome" || structuretype == "Cottage" || structuretype == "Rowhouse")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 186 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 208 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-224").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-186").style.background = "#f7fafd";
      document.getElementById(structuretype + "-208").style.background = "#f7fafd";
    }

    //MHA FEE C/A
    if (parameterid == 186 && (structuretype == "Condo" || structuretype == "Apartment")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 209 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 224 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-186").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-209").style.background = "#f7fafd";
      document.getElementById(structuretype + "-224").style.background = "#f7fafd";
    }
    if (parameterid == 209 && (structuretype == "Condo" || structuretype == "Apartment")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 186 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 224 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-209").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-186").style.background = "#f7fafd";
      document.getElementById(structuretype + "-224").style.background = "#f7fafd";
    }
    if (parameterid == 224 && (structuretype == "Condo" || structuretype == "Apartment")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 209 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 186 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-224").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-209").style.background = "#f7fafd";
      document.getElementById(structuretype + "-186").style.background = "#f7fafd";
    }

    //SF COST C/A
    if (parameterid == 198 && (structuretype == "Condo" || structuretype == "Apartment")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 201 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 229 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-198").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-201").style.background = "#f7fafd";
      document.getElementById(structuretype + "-229").style.background = "#f7fafd";
    }
    if (parameterid == 201 && (structuretype == "Condo" || structuretype == "Apartment")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 229 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-201").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-198").style.background = "#f7fafd";
      document.getElementById(structuretype + "-229").style.background = "#f7fafd";
    }
    if (parameterid == 229 && (structuretype == "Condo" || structuretype == "Apartment")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 201 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-229").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-198").style.background = "#f7fafd";
      document.getElementById(structuretype + "-201").style.background = "#f7fafd";
    }

    //SF COST SF
    if (parameterid == 198 && (structuretype == "Single Family")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 201 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 229 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-198").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-201").style.background = "#f7fafd";
      document.getElementById(structuretype + "-229").style.background = "#f7fafd";
    }
    // if(parameterid==200 && (structuretype=="Condo"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 229 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-200").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-198").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-229").style.background="#f7fafd";
    // }
    if (parameterid == 229 && (structuretype == "Condo")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 201 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-229").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-198").style.background = "#f7fafd";
      document.getElementById(structuretype + "-201").style.background = "#f7fafd";
    }

    //MHA FEE SF
    if (parameterid == 186 && (structuretype == "Single Family")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 223 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 224 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-186").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-223").style.background = "#f7fafd";
      document.getElementById(structuretype + "-224").style.background = "#f7fafd";
    }
    if (parameterid == 223 && (structuretype == "Single Family")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 186 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 224 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-223").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-186").style.background = "#f7fafd";
      document.getElementById(structuretype + "-224").style.background = "#f7fafd";
    }
    if (parameterid == 224 && (structuretype == "Single Family")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 186 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 223 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-224").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-186").style.background = "#f7fafd";
      document.getElementById(structuretype + "-223").style.background = "#f7fafd";
    }

    //SF HARD T
    if (parameterid == 110) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 99 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-110").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-99").style.background = "#f7fafd";
      document.getElementById(structuretype + "-239").style.background = "#f7fafd";
    }
    if (parameterid == 99) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 110 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-99").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-110").style.background = "#f7fafd";
      document.getElementById(structuretype + "-239").style.background = "#f7fafd";
    }
    if (parameterid == 239) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 110 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 99 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-239").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-110").style.background = "#f7fafd";
      document.getElementById(structuretype + "-99").style.background = "#f7fafd";
    }

    // //SF HARD Cot
    // if(parameterid==111 && (structuretype=="Cottage"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 101 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-111").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-101").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==101 && (structuretype=="Cottage"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 111 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-101").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-111").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==239 && (structuretype=="Cottage"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 101 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 111 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-239").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-101").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-111").style.background="#f7fafd";
    // }

    // //SF HARD Row
    // if(parameterid==112 && (structuretype=="Rowhouse"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 100 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-112").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-100").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==100 && (structuretype=="Rowhouse"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 112 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-100").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-112").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==239 && (structuretype=="Rowhouse"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 100 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 112 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-239").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-100").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-112").style.background="#f7fafd";
    // }

    // //SF HARD Apt
    // if(parameterid==113 && (structuretype=="Apartment"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 102 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-113").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-102").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==102 && (structuretype=="Apartment"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 113 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-102").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-113").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==239 && (structuretype=="Apartment"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 102 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 113 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-239").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-102").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-113").style.background="#f7fafd";
    // }

    // //SF HARD Condo
    // if(parameterid==114 && (structuretype=="Condo"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 103 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-114").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-103").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==103 && (structuretype=="Condo"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 114 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-103").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-114").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    // if(parameterid==239 && (structuretype=="Condo"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 114 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 103 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-239").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-114").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-103").style.background="#f7fafd";
    // }

    // //SF HARD SF
    // if(parameterid==109 && (structuretype=="Single Family"  )){
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 97 && item.structureType==structuretype).ischecked=false;
    //   props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType==structuretype).ischecked=false;
    //   document.getElementById(structuretype+"-109").style.background="#e7f0fa";
    //         document.getElementById(structuretype+"-97").style.background="#f7fafd";
    //         document.getElementById(structuretype+"-239").style.background="#f7fafd";
    // }
    if (parameterid == 97 && (structuretype == "Single Family")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 109 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 239 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-97").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-109").style.background = "#f7fafd";
      document.getElementById(structuretype + "-239").style.background = "#f7fafd";
    }
    if (parameterid == 239 && (structuretype == "Single Family")) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 109 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 97 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-239").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-109").style.background = "#f7fafd";
      document.getElementById(structuretype + "-97").style.background = "#f7fafd";
    }

    if (parameterid == 294) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 295 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 296 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-294").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-295").style.background = "#f7fafd";
      document.getElementById(structuretype + "-296").style.background = "#f7fafd";
    }
    if (parameterid == 295) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 294 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 296 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-295").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-294").style.background = "#f7fafd";
      document.getElementById(structuretype + "-296").style.background = "#f7fafd";
    }
    if (parameterid == 296) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 294 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 295 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-296").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-294").style.background = "#f7fafd";
      document.getElementById(structuretype + "-295").style.background = "#f7fafd";
    }

    if (parameterid == 297) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 298 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 299 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-297").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-298").style.background = "#f7fafd";
      document.getElementById(structuretype + "-299").style.background = "#f7fafd";
    }
    if (parameterid == 298) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 297 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 299 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-298").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-297").style.background = "#f7fafd";
      document.getElementById(structuretype + "-299").style.background = "#f7fafd";
    }
    if (parameterid == 299) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 297 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 298 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-299").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-297").style.background = "#f7fafd";
      document.getElementById(structuretype + "-298").style.background = "#f7fafd";
    }

    if (parameterid == 300) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 301 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 302 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-300").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-301").style.background = "#f7fafd";
      document.getElementById(structuretype + "-302").style.background = "#f7fafd";
    }
    if (parameterid == 301) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 302 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 300 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-301").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-302").style.background = "#f7fafd";
      document.getElementById(structuretype + "-300").style.background = "#f7fafd";
    }
    if (parameterid == 302) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 300 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 301 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-302").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-300").style.background = "#f7fafd";
      document.getElementById(structuretype + "-301").style.background = "#f7fafd";
    }

    if (parameterid == 305) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 306 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 307 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 308 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-305").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-306").style.background = "#f7fafd";
      document.getElementById(structuretype + "-307").style.background = "#f7fafd";
      document.getElementById(structuretype + "-308").style.background = "#f7fafd";
    }
    if (parameterid == 306) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 305 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 307 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 308 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-306").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-305").style.background = "#f7fafd";
      document.getElementById(structuretype + "-307").style.background = "#f7fafd";
      document.getElementById(structuretype + "-308").style.background = "#f7fafd";
    }
    if (parameterid == 307) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 306 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 305 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 308 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-307").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-306").style.background = "#f7fafd";
      document.getElementById(structuretype + "-305").style.background = "#f7fafd";
      document.getElementById(structuretype + "-308").style.background = "#f7fafd";
    }
    if (parameterid == 308) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 306 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 307 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 305 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-308").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-306").style.background = "#f7fafd";
      document.getElementById(structuretype + "-307").style.background = "#f7fafd";
      document.getElementById(structuretype + "-305").style.background = "#f7fafd";
    }


    if (parameterid == 300) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 301 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 302 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-300").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-301").style.background = "#f7fafd";
      document.getElementById(structuretype + "-302").style.background = "#f7fafd";
    }
    if (parameterid == 301) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 300 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 302 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-301").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-300").style.background = "#f7fafd";
      document.getElementById(structuretype + "-302").style.background = "#f7fafd";
    }
    if (parameterid == 302) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 300 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 301 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-302").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-300").style.background = "#f7fafd";
      document.getElementById(structuretype + "-301").style.background = "#f7fafd";
    }

    if (parameterid == 294) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 295 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 296 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-294").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-295").style.background = "#f7fafd";
      document.getElementById(structuretype + "-296").style.background = "#f7fafd";
    }
    if (parameterid == 295) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 294 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 296 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-295").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-294").style.background = "#f7fafd";
      document.getElementById(structuretype + "-296").style.background = "#f7fafd";
    }
    if (parameterid == 296) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 294 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 295 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-296").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-294").style.background = "#f7fafd";
      document.getElementById(structuretype + "-295").style.background = "#f7fafd";
    }

    if (parameterid == 297) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 298 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 299 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-297").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-298").style.background = "#f7fafd";
      document.getElementById(structuretype + "-299").style.background = "#f7fafd";
    }
    if (parameterid == 298) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 297 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 299 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-298").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-297").style.background = "#f7fafd";
      document.getElementById(structuretype + "-299").style.background = "#f7fafd";
    }
    if (parameterid == 299) {
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 297 && item.structureType == structuretype).ischecked = false;
      props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 298 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-299").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-297").style.background = "#f7fafd";
      document.getElementById(structuretype + "-298").style.background = "#f7fafd";
    }
    props.setData({ ...props.wholeEl, value: e.target.value, ischecked: true })

    if (e.target.value != "") {

      UpdateParameterValues(structuretype, props);
      //document.getElementById(e.target.id).value="0";

      // var formID=Cookies.get('FormID');
      // let newArr =[];
      //   newArr=({
      //    ParameterId: parameterid,ParameterName: lable,ParameterTypeId:ParameterTypeId,value: e.target.value,
      //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: Math.round((parseFloat(e.target.value.replaceAll(',',''))*homesqure)),perprojectvalue: Math.round((parseFloat(e.target.value.replaceAll(',',''))*homesqure)*NumberOfHomes), ParamOrder: 0,
      //  });

      //  var name=Cookies.get('username');
      //  let params = {
      //   username: name,
      //   Stage:"P",
      //   formId: formID,
      //   userType:"AutoSave",
      //   parameters: []
      //  };
      //  params.StructureTypes=[{
      //   StructureType: structuretype,
      //   Calculations: [newArr],}
      //  ]
      //  params = JSON.stringify({
      //    Body: params,
      //  });
      //  console.log(params)
      //  return axios
      //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
      //      headers: {
      //        "Content-Type": "application/json",
      //        Accept: "application/json",
      //      },
      //      crossorigin: true,
      //    })
      //    .then((res) => {
      //    // setLoading(false);
      //      return res.data;
      //    })
      //    .catch((e) => {
      //    // setLoading(false);
      //    });  
    }

  };


  function setPreviousValue(ID) {
    let e = ID.split('-')[1];

    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    let color1 = document.getElementById("color1").value;
    let color2 = document.getElementById("color2").value;
    let color3 = document.getElementById("color3").value;
    if (previuosID == 198) {
      document.getElementById(StructureType + "-198").style.background = color1;
      document.getElementById(StructureType + "-229").style.background = color3;
      document.getElementById(StructureType + "-201").style.background = color2;
      // if(StructureType=="Townhome"|| StructureType=="Cottage" || StructureType=="Rowhouse")
      // {

      // }
      // if(StructureType=="Apartment" || StructureType=="Condo")
      // {
      //   document.getElementById(StructureType+"-202").style.background=color2;
      // }
      // if(StructureType=="Single Family" )
      // {
      //   document.getElementById(StructureType+"-200").style.background=color2;
      // }
    }

    if (previuosID == 186) {
      document.getElementById(StructureType + "-186").style.background = color1;
      document.getElementById(StructureType + "-224").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-208").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-209").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-223").style.background = color2;
      }
    }
    if (previuosID == 88) {
      document.getElementById(StructureType + "-88").style.background = color1;
      document.getElementById(StructureType + "-238").style.background = color2;
    }
    if (previuosID == 89) {
      document.getElementById(StructureType + "-89").style.background = color1;
      document.getElementById(StructureType + "-237").style.background = color2;
    }
    if (previuosID == 91) {
      document.getElementById(StructureType + "-91").style.background = color1;
      document.getElementById(StructureType + "-236").style.background = color2;
    }
    if (previuosID == 105) {
      document.getElementById(StructureType + "-105").style.background = color1;
      document.getElementById(StructureType + "-235").style.background = color2;
    }
    if (previuosID == 90) {
      document.getElementById(StructureType + "-90").style.background = color1;
      document.getElementById(StructureType + "-234").style.background = color2;
    }
    if (previuosID == 106) {
      document.getElementById(StructureType + "-106").style.background = color1;
      document.getElementById(StructureType + "-233").style.background = color2;
    }
    if (previuosID == 87) {
      document.getElementById(StructureType + "-87").style.background = color1;
      document.getElementById(StructureType + "-232").style.background = color2;
    }
    if (previuosID == 109) {
      document.getElementById(StructureType + "-109").style.background = color1;
      document.getElementById(StructureType + "-97").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 115) {
      document.getElementById(StructureType + "-115").style.background = color1;
      document.getElementById(StructureType + "-104").style.background = color2;
      document.getElementById(StructureType + "-241").style.background = color3;
    }
    if (previuosID == 240) {
      document.getElementById(StructureType + "-240").style.background = color1;
      document.getElementById(StructureType + "-124").style.background = color2;
      document.getElementById(StructureType + "-242").style.background = color3;
    }
    if (previuosID == 113) {
      document.getElementById(StructureType + "-113").style.background = color1;
      document.getElementById(StructureType + "-102").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 114) {
      document.getElementById(StructureType + "-114").style.background = color1;
      document.getElementById(StructureType + "-103").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 112) {
      document.getElementById(StructureType + "-112").style.background = color1;
      document.getElementById(StructureType + "-100").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 111) {
      document.getElementById(StructureType + "-111").style.background = color1;
      document.getElementById(StructureType + "-101").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 110) {
      document.getElementById(StructureType + "-110").style.background = color1;
      document.getElementById(StructureType + "-99").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 45) {
      document.getElementById(StructureType + "-45").style.background = color1;
      document.getElementById(StructureType + "-246").style.background = color2;
      document.getElementById(StructureType + "-181").style.background = color3;
    }

    if (previuosID == 226) {
      document.getElementById(StructureType + "-226").style.background = color2;
      document.getElementById(StructureType + "-248").style.background = color3;
    }
    if (previuosID == 256) {
      document.getElementById(StructureType + "-256").style.background = color1;
      document.getElementById(StructureType + "-36").style.background = color2;
      document.getElementById(StructureType + "-258").style.background = color3;
    }
    if (previuosID == 41) {
      document.getElementById(StructureType + "-41").style.background = color1;
      document.getElementById(StructureType + "-259").style.background = color2;
      document.getElementById(StructureType + "-255").style.background = color3;
    }

    if (previuosID == 43) {
      document.getElementById(StructureType + "-43").style.background = color2;
      document.getElementById(StructureType + "-260").style.background = color3;
    }
    if (previuosID == 44) {
      document.getElementById(StructureType + "-44").style.background = color2;
      document.getElementById(StructureType + "-261").style.background = color3;
    }
    if (previuosID == 42) {
      document.getElementById(StructureType + "-42").style.background = color2;
      document.getElementById(StructureType + "-262").style.background = color3;
    }
  }
  function showInfo(ID) {

    let e = ID.split('-')[1];
    Setinfostyle(ID);
    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    if (previuosID != "" && previuosID != null) {
      setPreviousValue(ID);
    }
    document.getElementById(StructureType + "-85").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-86").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-217").style.background = '#f7f7f7';
    if (StructureType !== "Apartment" && StructureType !== "Condo") {
      document.getElementById(StructureType + "-96").style.background = 'transparent';
    }
    if (StructureType == "Apartment" || StructureType == "Condo") {
      document.getElementById(StructureType + "-79").style.background = 'transparent';

      document.getElementById(StructureType + "-71").style.background = '#f7f7f7';
    }

    document.getElementById("PreviousID").value = e;
    if (e == 198) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-198").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-229").style.backgroundColor;
      document.getElementById(StructureType + "-198").style.background = "#fffce6";
      document.getElementById(StructureType + "-229").style.background = "#fffce6";
      document.getElementById("color2").value = document.getElementById(StructureType + "-201").style.backgroundColor;
      document.getElementById(StructureType + "-201").style.background = "#fffce6";
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {

      }
      // if(StructureType=="Apartment" || StructureType=="Condo")
      // {
      //   document.getElementById("color2").value=document.getElementById(StructureType+"-202").style.backgroundColor;
      //   document.getElementById(StructureType+"-202").style.background="#fffce6";
      // }
      // if(StructureType=="Single Family" )
      // {
      //   document.getElementById("color2").value=document.getElementById(StructureType+"-200").style.backgroundColor;
      //   document.getElementById(StructureType+"-200").style.background="#fffce6";
      // }
    }
    if (e == 186) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-186").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-224").style.backgroundColor;

      document.getElementById(StructureType + "-186").style.background = "#fffce6";
      document.getElementById(StructureType + "-224").style.background = "#fffce6";
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById("color2").value = document.getElementById(StructureType + "-208").style.backgroundColor;

        document.getElementById(StructureType + "-208").style.background = "#fffce6";

      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById("color2").value = document.getElementById(StructureType + "-209").style.backgroundColor;

        document.getElementById(StructureType + "-209").style.background = "#fffce6";
      }
      if (StructureType == "Single Family") {
        document.getElementById("color2").value = document.getElementById(StructureType + "-223").style.backgroundColor;

        document.getElementById(StructureType + "-223").style.background = "#fffce6";
      }
    }
    if (e == 88) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-88").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-238").style.backgroundColor;

      document.getElementById(StructureType + "-88").style.background = '#fffce6';
      document.getElementById(StructureType + "-238").style.background = '#fffce6';
    }
    if (e == 89) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-89").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-237").style.backgroundColor;

      document.getElementById(StructureType + "-89").style.background = '#fffce6';
      document.getElementById(StructureType + "-237").style.background = '#fffce6';
    }
    if (e == 91) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-91").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-236").style.backgroundColor;

      document.getElementById(StructureType + "-91").style.background = '#fffce6';
      document.getElementById(StructureType + "-236").style.background = '#fffce6';
    }
    if (e == 105) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-105").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-235").style.backgroundColor;

      document.getElementById(StructureType + "-105").style.background = '#fffce6';
      document.getElementById(StructureType + "-235").style.background = '#fffce6';
    }
    if (e == 90) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-90").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-234").style.backgroundColor;

      document.getElementById(StructureType + "-90").style.background = '#fffce6';
      document.getElementById(StructureType + "-234").style.background = '#fffce6';
    }
    if (e == 106) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-106").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-233").style.backgroundColor;

      document.getElementById(StructureType + "-106").style.background = '#fffce6';
      document.getElementById(StructureType + "-233").style.background = '#fffce6';
    }
    if (e == 87) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-87").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-232").style.backgroundColor;

      document.getElementById(StructureType + "-87").style.background = '#fffce6';
      document.getElementById(StructureType + "-232").style.background = '#fffce6';
    }
    if (e == 109) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-109").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-97").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-239").style.backgroundColor;

      document.getElementById(StructureType + "-109").style.background = '#fffce6';
      document.getElementById(StructureType + "-97").style.background = '#fffce6';
      document.getElementById(StructureType + "-239").style.background = '#fffce6';
    }
    if (e == 113) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-113").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-102").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-239").style.backgroundColor;

      document.getElementById(StructureType + "-113").style.background = '#fffce6';
      document.getElementById(StructureType + "-102").style.background = '#fffce6';
      document.getElementById(StructureType + "-239").style.background = '#fffce6';
    }
    if (e == 114) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-114").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-103").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-239").style.backgroundColor;

      document.getElementById(StructureType + "-114").style.background = '#fffce6';
      document.getElementById(StructureType + "-103").style.background = '#fffce6';
      document.getElementById(StructureType + "-239").style.background = '#fffce6';
    }
    if (e == 112) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-112").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-100").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-239").style.backgroundColor;

      document.getElementById(StructureType + "-112").style.background = '#fffce6';
      document.getElementById(StructureType + "-100").style.background = '#fffce6';
      document.getElementById(StructureType + "-239").style.background = '#fffce6';
    }
    if (e == 111) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-111").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-101").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-239").style.backgroundColor;

      document.getElementById(StructureType + "-111").style.background = '#fffce6';
      document.getElementById(StructureType + "-101").style.background = '#fffce6';
      document.getElementById(StructureType + "-239").style.background = '#fffce6';
    }
    if (e == 110) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-110").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-99").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-239").style.backgroundColor;

      document.getElementById(StructureType + "-110").style.background = '#fffce6';
      document.getElementById(StructureType + "-99").style.background = '#fffce6';
      document.getElementById(StructureType + "-239").style.background = '#fffce6';
    }
    if (e == 115) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-115").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-104").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-241").style.backgroundColor;

      document.getElementById(StructureType + "-115").style.background = '#fffce6';
      document.getElementById(StructureType + "-104").style.background = '#fffce6';
      document.getElementById(StructureType + "-241").style.background = '#fffce6';
    }
    if (e == 240) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-240").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-124").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-242").style.backgroundColor;

      document.getElementById(StructureType + "-240").style.background = '#fffce6';
      document.getElementById(StructureType + "-124").style.background = '#fffce6';
      document.getElementById(StructureType + "-242").style.background = '#fffce6';
    }
    if (e == 198) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Soft Cost ";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "The cost of anything not considered construction costs or hard costs such as surveys,  architects, engineers, permits, insurance, property taxes and/or any cost occurred before construction starts excluding any financial fees. Demolition and abatement is included in this cost";

      SetIsHeader("Soft Cost ");
      SetIsinfo("The cost of anything not considered construction costs or hard costs such as surveys,  architects, engineers, permits, insurance, property taxes and/or any cost occurred before construction starts excluding any financial fees. Demolition and abatement is included in this cost");
      SetIsDisplay("info");
    }
    if (e == 186) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "MHA Fee ";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "A tax imposed by the city of Seattle to fund low-income housing. This fee is based off of the Used Floor Area for the project.";

      SetIsHeader("MHA Fee ");
      SetIsinfo("A tax imposed by the city of Seattle to fund low-income housing. This fee is based off of the Used Floor Area for the project.");
      SetIsDisplay("info");
    }
    if (e == 110 || e == 112 || e == 111 || e == 114 || e == 113 || e == 109) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "SF Hard Cost";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Anything considered construction cost from foundation to finish for building the Single Family Home(s).";

      SetIsHeader("SF Hard Cost");
      SetIsinfo("Anything considered construction cost from foundation to finish for building the Single Family Home(s).");
      SetIsDisplay("info");
    }
    if (e == 88) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Elevation Grade";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "The additional cost to shape and/or remove dirt given a project has slope.";

      SetIsHeader("Elevation Grade ");
      SetIsinfo("The additional cost to shape and/or remove dirt given a project has slope.");
      SetIsDisplay("info");
    }
    if (e == 89) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Water Main Costs";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Additional costs associated with a water main extension.";
      SetIsHeader("Water Main Costs");
      SetIsinfo("Additional costs associated with a water main extension.");
      SetIsDisplay("info");
    }
    if (e == 91) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Sewer Main Costs";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Additional costs associated with a sewer main extension.";
      SetIsHeader("Sewer Main Costs ");
      SetIsinfo("Additional costs associated with a sewer main extension.");
      SetIsDisplay("info");
    }
    if (e == 105) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Storm Main Costs";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Additional costs associated with a storm main extension";
      SetIsHeader("Storm Main Costs ");
      SetIsinfo("Additional costs associated with a storm main extension");
      SetIsDisplay("info");
    }
    if (e == 90) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Alley Reconstruction";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Additional costs associated with reconstruction of an alley.";
      SetIsHeader("Alley Reconstruction");
      SetIsinfo("Additional costs associated with reconstruction of an alley.");
      SetIsDisplay("info");
    }
    if (e == 106) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "Underground Parking";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Additional costs associated with the construction of a underground garage.";

      SetIsHeader("Underground Parking");
      SetIsinfo("Additional costs associated with the construction of a underground garage.");
      SetIsDisplay("info");
    }
    if (e == 115) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "AADU Hard Cost";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Anything considered construction cost from foundation to finish for building the AADU(s). ";

    }
    if (e == 240) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "DADU Hard Cost ";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Anything considered construction cost from foundation to finish for building the DADU(s).";

    }
    if (e == 87) {
      document.getElementById("HBuilding Cost Breakdown" + StructureType).innerText = "ECA / Extra Costs";
      document.getElementById("IBuilding Cost Breakdown" + StructureType).innerText = "Additional costs associated with Environmental Critical Areas and/or outside the scope of normal construction.";

      SetIsHeader("ECA / Extra Costs");
      SetIsinfo("Additional costs associated with Environmental Critical Areas and/or outside the scope of normal construction.");
      SetIsDisplay("info");
    }
    document.getElementById("Land Analysis" + StructureType).style.display = 'none';
    document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Site Potential" + StructureType).style.display = 'none';
    document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'inherit';
  }
  if (props.wholeEl.ParameterTypeId == 11 || props.wholeEl.ParameterTypeId == 12) {
    if (props.wholeEl.ParameterTypeId == 11) {
      if (props.name != "" && props.name != null && props.value != "-99") {
        return (
          <div draggable data-position={props.data.findIndex(obj => obj.ParameterId === props.id)}
            onDragStart={props.onDragStart}
            onDragOver={props.onDragOver}
            onDrop={props.onDrop}
            onDragLeave={props.onDragLeave} style={{ width: "100%" }} id={props.structureType + "-" + props.id + "-rowsoft"} class={softstyle + props.name.replace(" ", "") + " row softcost1"} >
            <div class="col-md-3 " onFocus={showtrash} id={props.structureType + "-" + props.id + "-div-soft"} >
              <div class="from  d-flex justify-content-between  align-items-center " >
                {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                <a tooltip="Drag" flow="down" id={props.structureType + "-" + props.id + "-drag-soft"} class="softicons"
                  style={{ display: "none", marginRight: "0.2rem", marginTop: "0.5rem" }} >
                  <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + props.id + "-drag-soft"} class=" fa fa-list"></i>


                </a>

                <a tooltip="Hold to save" flow="down" id={props.structureType + "-" + props.id + "-save-soft"} class="softicons " onMouseDown={handlePressStart1}
                  onMouseUp={handlePressEnd1}
                  onMouseLeave={handlePressEnd1} style={{ display: "none", marginTop: "0.5rem", marginRight: "0.2rem" }}>
                  <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + props.id + "-save-soft"} class="icon1 fa fa-save"></i>

                </a>

                <a tooltip="Hold to delete" flow="down" id={props.structureType + "-" + props.id + "-del-soft"} class="softicons" onMouseDown={handlePressStart}
                  onMouseUp={handlePressEnd}
                  onMouseLeave={handlePressEnd} style={{ display: "none", marginTop: "0.5rem" }}>
                  <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + props.id + "-del-soft"} class="icon fa fa-trash"></i>

                </a>



                <input type="text" onChange={lableChange} onBlur={lableChange1} id={props.structureType + "-" + props.id + "-label-soft"} class="form-control" style={{
                  marginLeft: "10%", border: "none",
                  background: "none",
                  color: "black",
                  fontSize: "12px",
                  fontWeight: "600"
                }} contenteditable="true" value={lable}
                />


              </div>
            </div>
            <div class="col-md-2 col-2" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id + "-persqt-soft"}
                    id={props.structureType + "-" + props.id + "-persqt-soft"}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    class={"form-control " + props.structureType + " " + props.name.replace(" ", "") + " advsoftcost persqt"}
                    style={{}}
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 col-5">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id + "-perhome-soft"}
                    id={props.structureType + "-" + props.id + "-perhome-soft"}
                    value={valueperhome}
                    onChange={onChangeperhome}
                    class={"form-control " + props.structureType + " " + props.name.replace(" ", "") + " advsoftcost perhome"}
                    style={{}}
                  />
                </div> </div>
            </div>
            <div class="col-md-3 col-5">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id + "-perproject-soft"}
                    id={props.structureType + "-" + props.id + "-perproject-soft"}
                    value={valueperproject}
                    onChange={onChangeperproject}
                    class={"form-control " + props.structureType + " " + props.name.replace(" ", "") + " advsoftcost perproject"}
                    style={{}}
                  />
                </div> </div>
            </div>
          </div>
        );
      }
      else {
        return (<></>);
      }
    }

    if (props.wholeEl.ParameterTypeId == 12) {

      if (props.name != "" && props.name != null && props.value != "-99") {
        return (
          <div draggable data-position={props.data.findIndex(obj => obj.ParameterId === props.id)}
            onDragStart={props.onDragStart}
            onDragOver={props.onDragOver}
            onDrop={props.onDrop}
            onDragLeave={props.onDragLeave} style={{ width: "100%" }} id={props.structureType + "-" + props.id + "-rowhard"} class={hardstyle + props.name.replace(" ", "") + " row hardcost1"} >
            <div class="col-md-3 " onFocus={showtrash} id={props.structureType + "-" + props.id + "-div-hard"}>
              <div class="from  d-flex  align-items-center ">
                {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                <a tooltip="Drag" flow="down" id={props.structureType + "-" + props.id + "-drag-hard"} class="hardicons"
                  style={{ display: "none", marginRight: "0.2rem", marginTop: "0.5rem" }} >
                  <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + props.id + "-drag-hard"} class=" fa fa-list"></i>


                </a>

                <a tooltip="Hold to save" flow="down" id={props.structureType + "-" + props.id + "-save-hard"} class="hardicons " onMouseDown={handlePressStart1}
                  onMouseUp={handlePressEnd1}
                  onMouseLeave={handlePressEnd1} style={{ display: "none", marginTop: "0.5rem", marginRight: "0.2rems" }}>
                  <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + props.id + "-save-hard"} class="icon1 fa fa-save"></i>

                </a>

                <a tooltip="Hold to delete" flow="down" id={props.structureType + "-" + props.id + "-del-hard"} class="hardicons" onMouseDown={handlePressStart}
                  onMouseUp={handlePressEnd}
                  onMouseLeave={handlePressEnd} style={{ display: "none", marginTop: "0.5rem" }}>
                  <i id={props.wholeEl.ParameterTypeId + "-" + props.structureType + "-" + props.id + "-del-hard"} class="icon fa fa-trash"></i>

                </a>

                {/* <label class="" style={{marginLeft:"10%"}} contenteditable="true">{props.name}      

          </label> */}
                <input type="text" onChange={lableChange} onBlur={lableChange1} id={props.structureType + "-" + props.id + "-label-hard"} class="form-control" style={{
                  marginLeft: "10%", border: "none",
                  background: "none",
                  color: "black",
                  fontSize: "12px",
                  fontWeight: "600"
                }} contenteditable="true" value={lable}
                />
              </div>
            </div>
            <div class="col-md-2 col-2" >
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id + "-persqt-hard"}
                    id={props.structureType + "-" + props.id + "-persqt-hard"}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={"form-control " + props.structureType + " " + props.name.replace(" ", "") + " advhardcost persqt"}
                    style={{}}
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 col-5">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id + "-perhome-hard"}
                    id={props.structureType + "-" + props.id + "-perhome-hard"}
                    value={valueperhome}
                    onChange={onChangeperhome}
                    class={"form-control " + props.structureType + " " + props.name.replace(" ", "") + " advhardcost perhome"}
                    style={{}}
                  />
                </div> </div>
            </div>
            <div class="col-md-3 col-5">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id + "-perproject-hard"}
                    id={props.structureType + "-" + props.id + "-perproject-hard"}
                    value={valueperproject}
                    onChange={onChangeperproject}
                    class={"form-control " + props.structureType + " " + props.name.replace(" ", "") + " advhardcost perproject"}
                    style={{}}
                  />
                </div> </div>
            </div>
          </div>
        );
      }
      else {
        return (<></>);
      }
    }




  }

  if (props.id == 313 || props.id == 303) {
    return (
      <>
        <div class="col-md-5" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <label class="">{props.name.split('per')[0]}

            </label>
          </div>
        </div>
        <div class="col-2 ismobile"></div>
        <div class="col-md-3 col-5" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly
                class={IsStyle}
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 309 || props.id == 311 || props.id == 310) {
    return (
      <>
        <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <label class="">{props.name.split('per')[0]}

            </label>
          </div>
        </div>
        <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 314 || props.id == 304) {
    return (
      <>

        <div class="col-md-3 col-5" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly
                class={IsStyle}
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 287 || props.id == 288) {
    if (props.id == 287) {
      return (
        <div class="row mb-1 hardcost">
          <div class="col-md-1 col-2">

            <label class="switch" >

              <input key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id} type="checkbox" checked={isChecked} onChange={onChange1} >
              </input>

              <span class="slider round">

              </span>
            </label>

          </div>
          <div class="col-md-10 col-9" style={{ marginLeft: "2.5%" }}><label >{props.name.split('Per')[0]}</label></div>
        </div>
      );
    }
    else {
      return (
        <div class="row mb-1 softcost" >
          <div class="col-md-1 col-2">

            <label class="switch" >

              <input key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id} type="checkbox" checked={isChecked} onChange={onChange1} >
              </input>

              <span class="slider round">

              </span>
            </label>

          </div>
          <div class="col-md-10 col-9" style={{ marginLeft: "2.5%" }}><label >{props.name.split('Per')[0]}</label></div>
        </div>
      );
    }
  }

  if (props.id == 207) {
    return (
      <>
        <div class="row" style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}>
          <div class="col-md-4" ></div>
          <div class="col-md-4 col-7" style={{ marginTop: "3%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class="" style={{ marginTop: "5%" }}>{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-3 col-5" style={{ marginTop: "3%" }}>
            <div class="from   justify-content-between  align-items-center ">

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control"
                style={{ borderRadius: "5px", fontWeight: "550" }}
              />

            </div>
          </div>
        </div>
        <div class="row" style={{ width: "100%", marginTop: "2%" }}>

          <p class="col-md-11" style={{ width: "100%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>Total Soft Cost + Total Construction Costs  = Total Project Building Cost
          </p></div>
      </>
    );
  }


  if (props.id == 88 || props.id == 89 || props.id == 91 || props.id == 105 || props.id == 90 || props.id == 106 || props.id == 87 || props.id == 128 || props.id == 126 || props.id == 107) {
    if (props.id == 128 || props.id == 126 || props.id == 107) {
      return (

        <>
          <div class="col-md-5" >
            <div class="from   justify-content-between  align-items-center ">
              <label class=""><u>{props.name.split('Per')[0]} </u>
              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class="form-control construction"
                  style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid", borderBottomLeftRadius: "5px" }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {

      return (
        <>
          <div class="col-md-5">
            <div class="from   justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>
              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input

                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  class={IsStyle}
                />
              </div>
            </div>
          </div>

        </>
      );

    }
  }
  // if(props.id==294)
  // {
  //   return (
  //   <>
  //   <div class="col-md-12 text-center input-box1 mt-3" >
  //   <div class="row" style={{width:"107%"}}>
  //   <div class="col-md-5"></div>
  //   <div class="col-md-3"><label class="d-inherit text-center">{structureType}</label></div>
  //   <div class="col-md-3"><label class="d-inherit text-center">Project</label></div>
  //   </div></div>
  //   <div class="col-md-5">
  //           <div class="from   justify-content-between  align-items-center ">
  //             <label class="">{props.name.split('Per')[0]}</label>
  //           </div>
  //           </div> 
  //             <div class="col-md-3">
  //             <div class="from   justify-content-between  align-items-center ">
  //             <div class="test">
  //             <input type="text"
  //              key={props.structureType +"-"+ props.id}
  //              id={props.structureType +"-"+ props.id}
  //             value={value}
  //              onChange={onChange}
  //             class={IsStyle}
  //             style={{borderTopLeftRadius:"5px"}}
  //             />
  //            </div>
  //           </div>
  //           </div>
  //       </>
  //   );
  // }
  if (props.id == 296 || props.id == 299 || props.id == 302 || props.id == 308) {



    return (

      <>


        <div class="col-md-1 col-2" >
          <div class="from   justify-content-between  align-items-center ">
            <div class="test2">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                // style={{paddingLeft:"1em"}}
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );

  }
  if (props.id == 295 || props.id == 298 || props.id == 301 || props.id == 307) {
    return (

      <>


        <div class="col-md-2 col" >
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 297 || props.id == 300 || props.id == 294 || props.id == 302) {
    return (
      <>

        <div class="col-md-5">
          <div class="from   justify-content-between  align-items-center ">
            <label class="">{props.name.split('Per')[0]}</label>
          </div>
        </div>
        <div class="col-2 ismobile"></div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                class={IsStyle}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  if (props.id == 290) {
    return (
      <>
        <div class="col-md-12 text-center input-box1 mt-3" id="advhartop">
          <div class="row" style={{ width: "100%" }}>

            <div class="col-md-3 col-12">
              <button type="button" class={hardstyle} onClick={addClickhard.bind(this, props.structureType)} id={props.id + "-" + props.structureType + "-btn"} style={{ border: "none", backgroundColor: "#2365B0", color: "white", hardstyle, borderRadius: "5px", float: "left" }} >+</button></div>

            <div class="col-md-2 col-2"><label class="d-inherit text-center">Per sqft</label></div>
            <div class="col-md-3 col-5"><label class="d-inherit text-center">{structureType}</label></div>
            <div class="col-md-3 col-5"><label class="d-inherit text-center">Project</label></div>
          </div></div>
        {createUIhard()}
      </>
    );
  }
  if (props.id == 289) {
    return (
      <>


        {/* <input type='button' value='add more' />
          <input type="submit" value="Submit" /> */}


        <div class="col-md-12 text-center input-box1 mt-3" id="advsoftop">
          <div class="row" style={{ width: "100%" }}>
            <div class="col-md-3 col-12"><button type="button" class={softstyle} onClick={addClick.bind(this, props.structureType)} id={props.id + "-" + props.structureType + "-btn"} style={{ border: "none", backgroundColor: "#2365B0", color: "white", borderRadius: "5px", float: "left" }} >+</button></div>
            <div class="col-md-2 col-2"><label class="d-inherit text-center">Per sqft</label></div>
            <div class="col-md-3 col-5"><label class="d-inherit text-center">{structureType}</label></div>
            <div class="col-md-3 col-5"><label class="d-inherit text-center">Project</label></div>
          </div></div>
        {createUIsoft()}
      </>
    );
  }
  if (props.id == 305) {


    return (
      <>
        <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   align-items-center ">
            <label class="">{props.name.split('per')[0]}

            </label>



          </div>
        </div>
        <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}

                class={IsStyle}
              />
            </div>
          </div>
        </div></>
    );

  }
  if (props.id == 186) {


    return (
      <>
        <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   align-items-center ">
            <a href="https://www.seattle.gov/documents/Departments/SDCI/Codes/MHA_rates.pdf" target="_blank"><img class="iconimg" style={{ width: "18%" }} src="/assets/img/outside-page-LB.svg"></img>
            </a><label class="">{props.name.split('Per')[0]}

              <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray">
                <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
              </svg></span>
            </label>



          </div>
        </div>
        <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}

                class={IsStyle}
              />
            </div>
          </div>
        </div></>
    );

  }
  else if (props.id == 198 || props.id == 110 || props.id == 230 || props.id == 112 || props.id == 111 || props.id == 114 || props.id == 113 || props.id == 115 || props.id == 109 || props.id == 240) {
    if (props.id == 230) {


      return (
        <>
          <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
            <div class="from   justify-content-between  align-items-center ">
              <label class=""><u>{props.name.split('Per')[0]}</u>
              </label>



            </div>
          </div>
          <div class="col-md-2 col-2">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class="form-control construction"
                  style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid", borderBottomLeftRadius: "5PX" }}
                />
              </div>
            </div>
          </div>
        </>
      );

    }
    else {
      if (props.id == 110 || props.id == 112 || props.id == 111 || props.id == 114 || props.id == 113) {

        return (
          <>
            <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
              <div class="from   justify-content-between  align-items-center ">
                <label class="">{props.name.split('Per')[0]}
                  <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray">
                    <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                  </svg></span>
                </label>
              </div>
            </div>
            <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input

                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}
                    style={{ borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px" }}
                  />
                </div>
              </div>
            </div>
          </>
        );

      }
      else if (props.id == 115 || props.id == 240) {


        if (props.ischecked == true) {

          return (
            <>
              <div class="col-md-3">
                <div class="from   justify-content-between  align-items-center ">
                  <label class="">{props.name.split('Per')[0]}

                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray">
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>
                  </label>



                </div>
              </div>
              <div class="col-md-2 col-2">
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input

                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}

                    />
                  </div>
                </div>
              </div></>
          );
        }
        else {
          return (
            <>
              <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
                <div class="from   justify-content-between  align-items-center ">
                  <label class="">{props.name.split('Per')[0]}
                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray">
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>
                  </label>



                </div>
              </div>
              <div class="col-md-2 col-2">
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}
                      style={{}}
                    />
                  </div>
                </div>
              </div></>
          );
        }
      }

      else {


        return (
          <>
            <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
              <div class="from   justify-content-between  align-items-center ">
                <label class="">{props.name.split('Per')[0]}

                  <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray">
                    <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                  </svg></span>
                </label>



              </div>
            </div>
            <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input

                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>
            </div></>
        );
      }

    }

  }
  else {
    if (props.id == 231 || props.id == 203 || props.id == 108) {

      if (props.id == 231) {
        return (<>

          <div class="col-md-3 col-5" style={{ marginBottom: "5%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class="form-control construction"
                  style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
                />
              </div>
            </div>
          </div></>);
      }
      if (props.id == 108) {
        return (<>

          <div class="col-md-3 col-5" style={{ marginBottom: "5%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class="form-control construction"
                  style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid", borderBottomRightRadius: "5px" }}
                />
              </div>
            </div>
          </div></>);
      }
      else {
        return (
          <>

            <div class="col-md-3 col-5" style={{ marginBottom: "5%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    readOnly
                    class="form-control construction"
                    style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
                  />
                </div>
              </div>
            </div></>
        );
      }

    }

    else {
      return (
        <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">

            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                style={{}}
              />
            </div> </div>
        </div>
      );
    }
  }
}

export default ConstructionCost;
